import React from "react";
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    card: {
        marginTop: 40
    }
}));


const RolePermissionLandingPage = () => {

    const classes = useStyles();


    return (
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <Card className={classes.card}>
                    <Typography sx={{ fontSize: 18 }} style={{ margin: '20px', textAlign: 'center' }} color="text.secondary" gutterBottom>
                        <b>Unauthorized Access</b>
                    </Typography>
                    <p style={{ margin: '20px', textAlign: 'center' }}>
                        Unfortunately, you do not have the role type required to access this page.<br />
                        Please contact the application admin for further information.
                    </p>
                </Card>
            </div>
        </div>
    );
}

export default RolePermissionLandingPage;
